export default {
  data: () => ({
    dataChangeBreakpoint: 0,
  }),
  computed: {
    isBreakpointMobile() {
      return this.$windowWidth < this.dataChangeBreakpoint;
    },
    isBreakpointDesktop() {
      return this.$windowWidth >= this.dataChangeBreakpoint;
    },
  },
};
